// Adds the auth token as a parameter to a url
export const addAuthTokenToURL = (url, signInToken) => {
  const [baseURL, params] = url.split('?');
  const paramsWithAuthToken = params ? `?${params}&auth_token=${signInToken}` : `?auth_token=${signInToken}`;
  return baseURL + paramsWithAuthToken;
};
